// Enhanced StatusBadge wrapper component for the SCAD system
// This component provides distinct styling for different company status types
import React from 'react';
import styled from 'styled-components';

const StatusBadgeWrapper = styled.div`
  .pending {
    background-color: rgba(245, 158, 11, 0.15);
    color: rgba(245, 158, 11, 0.9);
    border: 1px solid rgba(245, 158, 11, 0.3);
  }
  
  .accepted, .approved {
    background-color: rgba(16, 185, 129, 0.15);
    color: rgba(16, 185, 129, 0.9);
    border: 1px solid rgba(16, 185, 129, 0.3);
  }
  
  .rejected {
    background-color: rgba(239, 68, 68, 0.15);
    color: rgba(239, 68, 68, 0.9);
    border: 1px solid rgba(239, 68, 68, 0.3);
  }
  
  span {
    display: inline-block;
    padding: 0.35rem 0.8rem;
    border-radius: 6px;
    font-size: 0.8rem;
    font-weight: 600;
    letter-spacing: 0.5px;
    text-transform: uppercase;
    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
    transition: all 0.3s ease;
  }
  
  /* Add hover effect when the CompanyCard is hovered */
  .parent-hovered & span {
    transform: scale(1.05);
    box-shadow: 0 3px 8px rgba(0, 0, 0, 0.15);
  }
`;

const EnhancedStatusBadge = ({ status, className = '' }) => {
  let displayText = 'Unknown';
  let statusClass = '';
  
  switch(status) {
    case 'pending':
      displayText = 'Pending';
      statusClass = 'pending';
      break;
    case 'approved':
      displayText = 'Approved';
      statusClass = 'approved';
      break;
    case 'accepted':
      displayText = 'Accepted';
      statusClass = 'accepted';
      break;
    case 'rejected':
      displayText = 'Rejected';
      statusClass = 'rejected';
      break;
    default:
      displayText = status || 'Unknown';
  }
  
  return (
    <StatusBadgeWrapper className={className}>
      <span className={statusClass}>{displayText}</span>
    </StatusBadgeWrapper>
  );
};

export default EnhancedStatusBadge;
